import React from 'react';
import { Link } from 'react-router-dom';
import { SITE_INFO, BRAND_ASSETS } from '../data';

export default function Footer() {
  return (
    <footer className="bg-stone-100 border-t border-stone-300 text-stone-800">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          
          {/* Column 1: Company Profile & Badges */}
          <div className="space-y-4">
            <div>
              <Link to="/" className="inline-block bg-white p-2.5 rounded-xs border border-stone-200 shadow-xs hover:opacity-95 transition-opacity">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=360,format=auto,quality=90/assets/e25852aa-8434-4aa0-ac76-be91340b9170/imgi-8-slide1-edited.jpg"
                  alt="KTS-Entreprise A/S"
                  className="h-12 w-auto object-contain"
                />
              </Link>
            </div>

            <p className="text-xs text-stone-600 leading-relaxed">
              KTS-Entreprise A/S udfører jord-, kloak-, anlægs- og betonarbejde for private, erhverv og offentlige bygherrer i Nordsjælland og omegn.
            </p>

            {/* DI / Byg Garanti Badge */}
            <div className="pt-2">
              <a
                href={BRAND_ASSETS.diLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-white p-2.5 rounded-xs border border-stone-200 shadow-xs hover:border-[#0072c0] transition-colors group"
                aria-label="Medlem af DI Byggeri og Byg Garanti"
              >
                <img
                  src={BRAND_ASSETS.diBadge}
                  alt="Medlem af DI Byggeri"
                  className="h-7 w-auto object-contain"
                />
                <span className="block text-[10px] text-stone-700 uppercase tracking-widest mt-1.5 font-bold">
                  Sikret med Byg Garanti
                </span>
              </a>
            </div>
          </div>

          {/* Column 2: Fagområder */}
          <div>
            <h4 className="font-heading font-bold text-xs uppercase tracking-wider text-stone-900 mb-4 border-b border-stone-200 pb-2">
              Fagområder &amp; Ydelser
            </h4>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>
                <Link to="/entreprenerservice" className="text-stone-600 hover:text-[#0072c0] transition-colors">
                  Entreprenør og anlæg
                </Link>
              </li>
              <li>
                <Link to="/kloak-service" className="text-stone-600 hover:text-[#0072c0] transition-colors">
                  Kloak og klimasikring
                </Link>
              </li>
              <li>
                <Link to="/tv-inspektion" className="text-stone-600 hover:text-[#0072c0] transition-colors">
                  TV-inspektion og spuling
                </Link>
              </li>
              <li>
                <Link to="/betonarbejde" className="text-stone-600 hover:text-[#0072c0] transition-colors">
                  Betonarbejde
                </Link>
              </li>
              <li>
                <Link to="/bygningsaffald" className="text-stone-600 hover:text-[#0072c0] transition-colors">
                  På pladsen (Materialer &amp; genbrug)
                </Link>
              </li>
              <li>
                <Link to="/udlejning" className="text-stone-600 hover:text-[#0072c0] transition-colors">
                  Udlejning af køreplader
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Information & Genveje */}
          <div>
            <h4 className="font-heading font-bold text-xs uppercase tracking-wider text-stone-900 mb-4 border-b border-stone-200 pb-2">
              Information
            </h4>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>
                <Link to="/om-os" className="text-stone-600 hover:text-[#0072c0] transition-colors">
                  Om KTS-Entreprise
                </Link>
              </li>
              <li>
                <Link to="/smk" className="text-stone-600 hover:text-[#0072c0] transition-colors">
                  Statens Museum for Kunst
                </Link>
              </li>
              <li>
                <Link to="/klimatilpasning" className="text-stone-600 hover:text-[#0072c0] transition-colors">
                  Klimasikring &amp; Skybrud
                </Link>
              </li>
              <li>
                <Link to="/rottespaerre" className="text-stone-600 hover:text-[#0072c0] transition-colors">
                  Rottespærre montering
                </Link>
              </li>
              <li>
                <Link to="/minirensningsanlaeg" className="text-stone-600 hover:text-[#0072c0] transition-colors">
                  Minirenseanlæg
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-stone-600 hover:text-[#0072c0] transition-colors">
                  Kontakt os
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Virksomhedsoplysninger & Åbningstider */}
          <div className="space-y-3">
            <h4 className="font-heading font-bold text-xs uppercase tracking-wider text-stone-900 mb-4 border-b border-stone-200 pb-2">
              Virksomhedsoplysninger
            </h4>
            
            <div className="text-xs sm:text-sm text-stone-700 space-y-1.5">
              <p className="font-bold text-stone-900">KTS-Entreprise A/S</p>
              <p>Industrivej 3, 3300 Frederiksværk</p>
              <p className="text-stone-500">CVR-nr. 16682144</p>
              
              <div className="pt-2 space-y-1">
                <p>
                  <span className="font-semibold text-stone-900">Telefon: </span>
                  <a href={`tel:${SITE_INFO.mainPhone.replace(/\s+/g, '')}`} className="font-mono text-[#0072c0] hover:underline font-bold">
                    {SITE_INFO.mainPhone}
                  </a>
                </p>
                <p>
                  <span className="font-semibold text-stone-900">E-mail: </span>
                  <a href={`mailto:${SITE_INFO.email}`} className="text-[#0072c0] hover:underline">
                    {SITE_INFO.email}
                  </a>
                </p>
                <p>
                  <span className="font-semibold text-stone-900">Faktura: </span>
                  <a href={`mailto:${SITE_INFO.fakturaEmail}`} className="text-[#0072c0] hover:underline">
                    {SITE_INFO.fakturaEmail}
                  </a>
                </p>
              </div>

              <div className="pt-3 border-t border-stone-200 text-xs text-stone-600">
                <p className="font-semibold text-stone-900 mb-1">Åbningstider på pladsen:</p>
                <p>Mandag–torsdag: 6.30–15.30</p>
                <p>Fredag: 6.30–15.00</p>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Copyright & Meta */}
      <div className="bg-stone-200 border-t border-stone-300 py-4 text-center text-xs text-stone-600 px-4">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
          <div>
            &copy; {new Date().getFullYear()} KTS-Entreprise A/S · CVR: 16682144 · Industrivej 3, 3300 Frederiksværk
          </div>
          <div className="flex items-center gap-4 text-[11px] text-stone-500">
            <span>Autoriseret kloakmestervirksomhed</span>
            <span>·</span>
            <span>Medlem af DI Byggeri</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
